import { useEffect } from 'react';

// Callback type for keyboard event handlers
type ShortcutHandler = (event: KeyboardEvent) => void;

// Interface for defining shortcut options
export interface ShortcutOptions {
  ctrlKey: boolean | undefined;
  shiftKey: boolean | undefined;
  metaKey: boolean | undefined;
}

/**
 * Hook to register keyboard shortcuts.
 * @param keys - Array of keys that define the shortcut.
 * @param callback - Function to call when the shortcut is triggered.
 * @param options - Options object to define the shortcut (e.g., Cmd + Shift).
 */
 export function useKeyboardShortcut(
  keys: Array<string>,
  callback: ShortcutHandler,
  options?: ShortcutOptions
) {
  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      const keyMatch = keys.includes(event.key.toLowerCase());

      const shiftOk =
        options?.shiftKey === undefined ? true : event.shiftKey === options.shiftKey;

      const ctrlWanted = options?.ctrlKey;
      const metaWanted = options?.metaKey;

      // Wenn beides true ist: "Ctrl ODER Cmd" erlauben (cross-platform)
      const modOk =
        ctrlWanted === true && metaWanted === true
          ? event.ctrlKey || event.metaKey
          : (ctrlWanted === undefined ? true : event.ctrlKey === ctrlWanted) &&
            (metaWanted === undefined ? true : event.metaKey === metaWanted);

      if (keyMatch && modOk && shiftOk) {
        event.preventDefault();
        callback(event);
      }
    };

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [keys.join(','), callback, options?.ctrlKey, options?.metaKey, options?.shiftKey]);
}

